import React, { useState, useEffect } from 'react';

/**
 * Catch-all page that handles two cases:
 * 1. SPA routes (whitelisted in +data.tsx) — dynamically loads App on the client
 * 2. Unknown routes — +data.tsx throws render(404) so this component never renders
 *
 * App uses BrowserRouter which requires `window`, so we render a loading shell
 * during SSR and load the full SPA client-side only.
 */
export default function CatchAllPage() {
  const [AppComponent, setAppComponent] = useState<React.ComponentType | null>(null);

  useEffect(() => {
    import('../../../App').then((mod) => {
      setAppComponent(() => mod.default);
    });
  }, []);

  if (!AppComponent) {
    return <div className="min-h-screen" />;
  }

  return <AppComponent />;
}
